import styled from "styled-components";

export const Btn = styled.button`
  background-color: #9557e8;
  color: #ffffff;
  border: none;
  padding: 6px 20px;
  font-size: 14px;
  border-radius: 20px;
`;

export const List = styled.ul`
  display: flex;
  gap: 20px;
  justify-content: center;
`;

export const Section = styled.section`
  padding: 20px 0;
  background-color: #ebddfd;
`;
